import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import Has from '../../component/Permission/Has';
import './Roles.css'
import RoleInformation  from '../../component/Role/RoleInformation';
import RolePermissions from '../../component/Role/RolePermissions';
import { FF_ROLES_PAGE } from '../../config/FeatureFlagTypes';
import { U_USER_ADMIN } from '../../config/PermissionTypes';
import { saveCompanyRole } from '../../service/CompanyService';
import { useCompany, useCompanyPermission } from '../../component/CompanySelection/CompanyContext';
import { getUrl } from '../../util/EfupUtility';
import { Alert } from '../../component/Alert/Alert';
import LoadingSpinner from '../../component/LoadingSpinner/LoadingSpinner';

export default function CreateRole(props) {
    const [role, setRole] = useState({
        roleUuid: "",
        roleName: "",
        description: "",
        permissions: []
    });
    const [errors, setErrors] = useState({});
    const [savePending, setSavePending] = useState(false);
    const [banner, setBanner] = useState({
        show: false,
        type: "success",
        message: ""
    });
    const { companyNumber } = useCompany();

    //if permissions are not loaded, show loading spinner
    const companyPermission = useCompanyPermission();
    if (!companyPermission) {
        return (
            <div id="dashboard-loader">
                <LoadingSpinner blue />
            </div>
        );
    }

    const isSaveDisabled = () => {
        const errorsExist = !_.isEmpty(errors);
        return !role.roleName || errorsExist || savePending;
    }

    function handleRoleUpdate(field, value) {
        let updatedRole = {...role};
        updatedRole[field] = value
        setRole(updatedRole);
    }

    const handleSaveRole = async () => {
        setSavePending(true);
        saveCompanyRole(role, companyNumber, callbackHandler, callbackHandlerError);
    }
    
    function callbackHandlerError(response) {
        let message = "Something went wrong. Please try again later."
        if (response?.status === 400) {
            message = response.data;
        }
        showBanner("error", message);
        setSavePending(false);
    }

    function callbackHandler(response) {
        let message = response.data.message;
        showBanner("success", message);
        setSavePending(false);
    }
    
    const showBanner = (type, message) => {
        setBanner({
            show: true,
            type: type,
            message: message
        })
    }  

    return (
        <><Has isPageLevel={true} featureFlag={FF_ROLES_PAGE} permission={U_USER_ADMIN}>
            {/* <!-- Page content--> */}
            <div className="container-fluid create-role-page" data-testid="create-role-page">
                <div className="cb-row page-title-area">
                    <div className="cb-col-xs-8 cb-col-lg-8 page-title">
                        <h1 data-testid="create-role-page-header-title">Create Role</h1>
                    </div>
                </div>
                {banner.show && 
                    <Alert type={`${banner.type}`} handleOnClose={() =>  setBanner({ show: false, message: ""})} dataTestId='create-role-notification'>
                        <div style={{ fontWeight: '500' }}>{banner.message}</div>
                    </Alert>}
                <div className="role-info-container" data-testid="role-info-fields">
                    <div className="sectionTitle">New Role Information</div>
                    <RoleInformation 
                        readOnly={false}
                        roleName={role.roleName}
                        description={role.description}
                        errors={errors}
                        setErrors={setErrors}
                        handleFieldUpdate={handleRoleUpdate}
                    />
                </div>

                <div className="permissions-container" data-testid="role-permission-options">
                    <div className="sectionTitle">Permissions</div>
                    <RolePermissions 
                        permissions={role.permissions} 
                        handlePermissionUpdate={handleRoleUpdate} />
                </div>
                <div className="role-buttons" data-testid="create-role-buttons">
                    <Link to={getUrl(companyNumber, `/roles`)}>
                        <button
                            type="button"
                            className="cb-btn cb-btn-outline-secondary"
                            data-testid="create-role-cancel"
                            disabled={false}
                            onClick={() => null}>
                            Cancel
                        </button>
                    </Link>
                    <button 
                        className="cb-btn cb-btn-primary" 
                        data-testid="create-role-submit" 
                        disabled={isSaveDisabled()}
                        onClick={() => handleSaveRole()}>
                        Create Role
                    </button>
                </div>
            </div>
        </Has></>
    );
}